module.exports = {"542231100":"隆子镇","542231101":"日当镇","542231200":"加玉乡","542231201":"列麦乡","542231202":"热荣乡","542231203":"三安曲林乡","542231204":"准巴乡","542231205":"斗玉珞巴民族乡","542231206":"雪沙乡","542231207":"扎日乡","542231208":"玉麦乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542231.json
// module id = 2755
// module chunks = 0